// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__3aE2N","load1":"Loader_load1__30WB8"};